import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Agegroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "agegroup";
    }
}

export function Agegroup$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Agegroup", void 0, Agegroup, Metadata_StringCategory$reflection());
}

export function Agegroup_$ctor_Z721C83C5(aName) {
    return new Agegroup(aName);
}

export class Bred extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "bred";
    }
}

export function Bred$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Bred", void 0, Bred, Metadata_StringCategory$reflection());
}

export function Bred_$ctor_Z721C83C5(aName) {
    return new Bred(aName);
}

export class Bredreg extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "bredreg";
    }
}

export function Bredreg$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Bredreg", void 0, Bredreg, Metadata_StringCategory$reflection());
}

export function Bredreg_$ctor_Z721C83C5(aName) {
    return new Bredreg(aName);
}

export class Abode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "abode";
    }
}

export function Abode$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Abode", void 0, Abode, Metadata_StringCategory$reflection());
}

export function Abode_$ctor_Z721C83C5(aName) {
    return new Abode(aName);
}

export class Abodereg extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "abodereg";
    }
}

export function Abodereg$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Abodereg", void 0, Abodereg, Metadata_StringCategory$reflection());
}

export function Abodereg_$ctor_Z721C83C5(aName) {
    return new Abodereg(aName);
}

export class Longest extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "longest";
    }
}

export function Longest$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Longest", void 0, Longest, Metadata_StringCategory$reflection());
}

export function Longest_$ctor_Z721C83C5(aName) {
    return new Longest(aName);
}

export class Longestreg extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "longestreg";
    }
}

export function Longestreg$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Longestreg", void 0, Longestreg, Metadata_StringCategory$reflection());
}

export function Longestreg_$ctor_Z721C83C5(aName) {
    return new Longestreg(aName);
}

export class Edu extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "edu";
    }
}

export function Edu$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Edu", void 0, Edu, Metadata_StringCategory$reflection());
}

export function Edu_$ctor_Z721C83C5(aName) {
    return new Edu(aName);
}

export class Pro extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pro";
    }
}

export function Pro$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Pro", void 0, Pro, Metadata_StringCategory$reflection());
}

export function Pro_$ctor_Z721C83C5(aName) {
    return new Pro(aName);
}

export class Rep extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rep";
    }
}

export function Rep$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Rep", void 0, Rep, Metadata_StringCategory$reflection());
}

export function Rep_$ctor_Z721C83C5(aName) {
    return new Rep(aName);
}

export class Notes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "notes";
    }
}

export function Notes$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Notes", void 0, Notes, Metadata_StringCategory$reflection());
}

export function Notes_$ctor_Z721C83C5(aName) {
    return new Notes(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.NotaOslo.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

